import React, { useEffect, useState } from "react"
import Loader from "react-loader-spinner"
import Button from "../../../shared/components/atoms/button/button"
import MyPointsService from "../../../shared/services/my-points-service.js"
import FormatDate from "../../../shared/utils/formartDate"
import formatNumer from "../../../shared/utils/formatNumber"
import { siteUrl } from "../../../shared/utils/siteUrl"
import CardMyPoints from "../../atoms/card-my-points/card-my-points"
import CardOrders from "../../atoms/card-orders/card-orders"
import EmptyHistory from "../../atoms/empty-history/empty-history"
import Paginator from "../../atoms/paginator/paginator"
import "./my-points.scss"
import CardSamples from "../../atoms/card-samples/card-samples"
import { graphql, useStaticQuery } from "gatsby"
import { withBottomLine } from "../../../shared/utils/formatString"
import { buttonClickTransversal } from "../../../utils/loyaltyDatalayer"
import { requestExpiredPoints } from "../../../utils/requestExpiredPoints.js"

const MyPoints = props => {
  const {
    mobile,
    totalPoints,
    pointsAccumulated,
    data,
    setData,
    pointsPresent,
    setTotalPagesAccummulated,
    totalPagesAccummulated,
    requestMade,
    setRequestMade,
    historyAcumulated,
    category = "mis_puntos",
  } = props
  const btnmypoints = ["Acumulados", "Concursos", "Pedidos", "Muestras"]
  const [infoPointsToExpire, setPointsToExpire] = useState(0)
  const [btnActive, setbtnActive] = useState("Acumulados")
  // const [requestMade, setRequestMade] = useState(false)
  const [listRedem, setListRedem] = useState([])
  const [listSamples, setListSamples] = useState([])

  const [initialDate, setInitialDate] = useState("DD/MM/AAAA")
  const [finalDate, setFinalDate] = useState("")
  const [pageLoad, setpageLoad] = useState(false)
  const [myMovements, setmyMovements] = useState(false)
  const [errorDate, seterrorDate] = useState(false)
  // const [loadReq, setloadReq] = useState(false)

  const { allContentfulNolPaises } = useStaticQuery(
    graphql`
      query newLine {
        allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            codigoIcu
            tieneSeguimientoMuestraVConfident
          }
        }
      }
    `
  )

  const haveTrackSample = allContentfulNolPaises.nodes.filter(
    country => country.codigoIcu === process.env.LOCALE
  )[0].tieneSeguimientoMuestraVConfident

  useEffect(() => {
    if (localStorage.getItem("USER_INFO")) {
      requestExpiredPoints().then(points => {
        setPointsToExpire(points)
      })
      /* setPointsToExpire(
        JSON.parse(localStorage.getItem("USER_INFO")).userPoints.pointsToExpire,
      ) */
    }
    // getDataHistory()
    setpageLoad(true)
  }, [])

  if (pageLoad && mobile && !myMovements) {
    setmyMovements(true)
    setTimeout(() => {
      window.scrollTo(0, 700)
    }, 200)
  }

  if (pageLoad && !mobile && !myMovements) {
    setmyMovements(true)
    setTimeout(() => {
      window.scrollTo(0, 510)
    }, 200)
  }

  const activity = (page = 0, size = 10, initialDate = "", finalDate = "") => {
    setRequestMade(false)
    var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
    var config = {
      headers: {
        Authorization: tokenId,
      },
    }
    MyPointsService.getListActivity(page, size, initialDate, finalDate, config)
      .then(res => {
        if (res.status === 400 || res.status === 404) {
          setRequestMade(true)
        } else if (res.status === 200) {
          let activity = res.data
          setRequestMade(true)
          setData(activity)
          setTotalPagesAccummulated(res.metadata.limit)
        }
      })
      .catch(err => console.log("Error:", err))
  }

  const redem = (page = 0, size = 10, initialDate = "", finalDate = "") => {
    setRequestMade(false)
    var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
    var config = {
      headers: {
        Authorization: tokenId,
      },
    }
    MyPointsService.getListOrders(page, size, initialDate, finalDate, config)
      .then(res => {
        if (res.status === 400 || res.status === 404) {
          // console.log("status 400", res);
          setRequestMade(true)
        } else if (res.status === 200) {
          // console.log("Se realizo la peticion exitosamente", res)
          let redem = res.data
          setRequestMade(true)
          setListRedem(redem)
          setTotalPagesAccummulated(res.metadata.limit)
        }
      })
      .catch(err => console.log("Error:", err))
  }

  // service for get samples
  const samples = (page = 0, size = 10, initialDate = "", finalDate = "") => {
    setRequestMade(false)
    var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
    var config = {
      headers: {
        Authorization: tokenId,
      },
    }

    MyPointsService.getListSamplesVConfident(
      page,
      size,
      initialDate,
      finalDate,
      config
    )
      .then(res => {
        if (res.status === 400 || res.status === 404) {
          setRequestMade(true)
        } else if (res.status === 200) {
          let samples = res.data
          setRequestMade(true)
          setListSamples(samples)
          setTotalPagesAccummulated(res.metadata.limit)
        } else {
          setRequestMade(true)
        }
      })
      .catch(err => {
        console.log("Error:", err)
      })
  }

  const fetchPage = pageNumber => {
    switch (btnActive) {
      case "Acumulados":
        historyAcumulated(pageNumber - 1)
        break
      case "Concursos":
        activity(pageNumber - 1)
        break
      case "Pedidos":
        redem(pageNumber - 1)
        break
      case "Muestras":
        samples(pageNumber - 1)
        break

      default:
        break
    }
  }

  const getDataHistory = e => {
    if (errorDate) {
      seterrorDate(false)
      setInitialDate("DD/MM/AAAA")
    }

    e.preventDefault()
    e.stopPropagation()
    setbtnActive("Acumulados")
    if (listRedem) {
      setListRedem([])
    }
    if (data) {
      setData([])
    }
    if (listSamples) {
      setListSamples([])
    }
    historyAcumulated()
    setTotalPagesAccummulated(totalPagesAccummulated)
  }

  const handleRedem = e => {
    if (errorDate) {
      seterrorDate(false)
      setInitialDate("DD/MM/AAAA")
    }
    e.preventDefault()
    setData([])
    setListSamples([])
    setListRedem([])
    setbtnActive("Pedidos")
    redem()
  }

  const getUpdateData = e => {
    if (errorDate) {
      seterrorDate(false)
      setInitialDate("DD/MM/AAAA")
    }
    e.preventDefault()
    setbtnActive("Concursos")
    setData([])
    setListRedem([])
    setListSamples([])
    activity()
  }

  const getSamples = e => {
    if (errorDate) {
      seterrorDate(false)
      setInitialDate("DD/MM/AAAA")
    }
    e.preventDefault()
    setbtnActive("Muestras")
    setData([])
    setListRedem([])
    setListSamples([])
    samples()
  }

  const handleFilterForDate = () => {
    if (!errorDate) {
      if (
        initialDate !== "" &&
        finalDate !== "" &&
        compareDates(initialDate, finalDate)
      ) {
        let isDateInitial = isDate(initialDate)
        let isDateFinal = isDate(finalDate)
        if (btnActive === "Acumulados") {
          historyAcumulated(0, 10, isDateInitial, isDateFinal)
        }
        if (btnActive === "Concursos") {
          activity(0, 10, isDateInitial, isDateFinal)
        }
        if (btnActive === "Pedidos") {
          redem(0, 10, isDateInitial, isDateFinal)
        }
        if (btnActive === "Muestras") {
          samples(0, 10, isDateInitial, isDateFinal)
        }
      } else if (initialDate !== "" && finalDate === "") {
        let isDateInitial = isDate(initialDate)
        // console.log(isDateInitial)
        var f = new Date()
        let isDateFinal =
          f.getDate() + "/" + (f.getMonth() + 1) + "/" + f.getFullYear()
        let isdateNow =
          f.getFullYear() + "-" + (f.getMonth() + 1) + "-" + f.getDate()
        if (!compareDates(initialDate, isdateNow)) {
          seterrorDate(true)
          return
        }
        if (btnActive === "Acumulados") {
          historyAcumulated(0, 10, isDateInitial, isDateFinal)
        }
        if (btnActive === "Concursos") {
          activity(0, 10, isDateInitial, isDateFinal)
        }
        if (btnActive === "Pedidos") {
          redem(0, 10, isDateInitial, isDateFinal)
        }
        if (btnActive === "Muestras") {
          samples(0, 10, isDateInitial, isDateFinal)
        }
      } else {
        // return alert('Opps!! Por favor ingresar las fechas correctamente');
        seterrorDate(true)
        return
      }
    }
  }

  const isDate = date => {
    if (date) {
      let realDate = date.split("-")
      return realDate[2] + "/" + realDate[1] + "/" + realDate[0]
    } else {
      return ""
    }
  }

  const compareDates = (initialDate, finalDate) => {
    let initAux = initialDate.split("-")
    let finaAux = finalDate.split("-")
    let initdate = new Date(initAux[0], initAux[1], initAux[2])
    let finadate = new Date(finaAux[0], finaAux[1], finaAux[2])
    if (initdate <= finadate) {
      return true
    }
    return false
  }

  const keyScroll = () => {
    window.scrollTo(0, 0)
  }

  const competitionRedirect = () => {
    buttonClickTransversal({
      category: withBottomLine(category),
      label: "Ir a concursos",
    })
    window.location.href = siteUrl + "/magazin/concursos/"
  }

  const storeRedirect = () => {
    buttonClickTransversal({
      category: withBottomLine(category),
      label: "Ir a tienda",
    })
    window.location.href = siteUrl + "/mis-puntos/que-puedo-ganar/"
  }

  // add temporaly expired date for countries
  const default_date = "8 de abril"
  const expireddate =
    {
      "es-CO": default_date,
      "es-EC": "11 de abril",
      "es-PE": "10 de abril",
      "es-PY": "5 de abril",
      "es-AR": "4 de abril",
      "es-DO": "1 de abril",
      "es-PR": "2 de abril",
      "es-CL": "3 de abril",
    }[process.env.LOCALE] || default_date

  return (
    <div className="f-mypoints">
      {!mobile ? (
        <div className="f-mypoints-container">
          <div className="f-mypoints-header">
            <h1 className="f-mypoints-header-title">
              Tienes{" "}
              <span id="have-points" className="f-mypoints-header-title-points">
                {formatNumer(totalPoints)}
              </span>{" "}
              puntos
            </h1>
            <p className="f-mypoints-header-subtitle--big">
              {formatNumer(pointsPresent)} regalo de Nosotras |{" "}
              <span id="points-accumulation">
                {" "}
                {formatNumer(pointsAccumulated)}{" "}
              </span>{" "}
              puntos por empaque
            </p>
            <p className="f-mypoints-header-title">
              Puntos por vencer{" "}{formatNumer(infoPointsToExpire)}
              {infoPointsToExpire > 0 && <span className="f-mypoints-header-title">
              {" |"}{" "}Vencen el: {expireddate}
              </span>}
            </p>
          </div>
        </div>
      ) : (
        <div className="f-mypoints-container">
          <div className="f-mypoints-header">
            <h1 className="f-mypoints-header-title">
              Tienes{" "}
              <span id="have-points" className="f-mypoints-header-title-points">
                {formatNumer(totalPoints)}
              </span>{" "}
              puntos
            </h1>
            <p className="f-mypoints-header-subtitle--big">
              {formatNumer(pointsPresent)} regalo Nosotras
            </p>
            <p className="f-mypoints-header-subtitle--big">
              {" "}
              <span id="points-accumulation">
                {" "}
                {formatNumer(pointsAccumulated)}
              </span>{" "}
              puntos por empaque
            </p>
            <p className="f-mypoints-header-title">
              Puntos por vencer{" "}{formatNumer(infoPointsToExpire)}{" "}
            </p>
            <p className="f-mypoints-header-title">
                {" "}Vencen el: {expireddate}
            </p>
          </div>
        </div>
      )}
      <div className={"f-mypoints-filter-container"}>
        <div className="f-mypoints-filter-btn">
          <button
            onClick={e => {
              buttonClickTransversal({
                category: withBottomLine(category),
                label: btnmypoints[0],
              })
              getDataHistory(e)
            }}
            className={
              "f-secondary-pink btn-filter " +
              (btnActive === "Acumulados" ? "f-active-btn" : "")
            }
            disabled={!requestMade}
          >
            {btnmypoints[0]}
          </button>
          {process.env.LOCALE === "es-UY" ? null : (
            <>
              <button
                onClick={e => {
                  buttonClickTransversal({
                    category: withBottomLine(category),
                    label: btnmypoints[1],
                  })
                  getUpdateData(e)
                }}
                className={
                  "f-secondary-pink btn-filter " +
                  (btnActive === "Concursos" ? "f-active-btn" : "")
                }
                disabled={!requestMade}
              >
                {btnmypoints[1]}
              </button>
              <button
                onClick={e => {
                  buttonClickTransversal({
                    category: withBottomLine(category),
                    label: btnmypoints[2],
                  })
                  handleRedem(e)
                }}
                className={
                  "f-secondary-pink btn-filter " +
                  (btnActive === "Pedidos" ? "f-active-btn" : "")
                }
                disabled={!requestMade}
              >
                <span className="icon-check f-icon-orders"></span>{" "}
                {btnmypoints[2]}
              </button>
            </>
          )}

          {haveTrackSample && (
            <button
              onClick={e => {
                buttonClickTransversal({
                  category: withBottomLine(category),
                  label: btnmypoints[3],
                })
                getSamples(e)
              }}
              className={
                "f-secondary-pink btn-filter " +
                (btnActive === "Muestras" ? "f-active-btn" : "")
              }
              disabled={!requestMade}
            >
              {btnmypoints[3]}
            </button>
          )}
        </div>
      </div>
      <div className="f-mypoints-seccion-date">
        <div className="f-mypoints-date">
          <div className="f-mypoints-date-container">
            <label className="f-input-label ">Desde</label>
            <input
              type="date"
              className="f-input-date f-date-mobile"
              name="f-name-input"
              value={initialDate}
              onChange={e => {
                setInitialDate(e.target.value)
              }}
              required
            />
            <span className="icon-down"></span>
            {errorDate && (
              <label className="f-label-error">*Fecha inválida</label>
            )}
          </div>
          <div className="f-mypoints-date-container f-margin-date">
            <label className="f-input-label">Hasta</label>
            <input
              type="date"
              className="f-input-date"
              name="f-name-input"
              value={finalDate}
              onChange={e => {
                setFinalDate(e.target.value)
              }}
            />
            <span className="icon-down"></span>
          </div>
          {!mobile && (
            <div className="f-mypoints-search" onClick={handleFilterForDate}>
              <span className="icon-search f-mypoints-search-icon" />
            </div>
          )}
        </div>
      </div>
      {mobile && (
        <div className="f-btn-container">
          <Button
            className="primary-pink f-btn-container-filter"
            title="Filtrar"
            onClick={handleFilterForDate}
          />
        </div>
      )}

      {(btnActive === "Acumulados" || btnActive === "Concursos") && (
        <>
          {data.length > 0 ? (
            <>
              <div className="f-mypoints-seccion-result">
                {!mobile ? (
                  <>
                    {data.map((items, index) => {
                      return (
                        <div key={index} className="f-mypoints-result-search">
                          <div className="f-mypoints-result-search-container">
                            <div className="f-mypoints-result-search-img-container">
                              {items.category === "Toallas Higiénicas" &&
                                !items.gift && (
                                  <img
                                    className="f-mypoints-result-search-img"
                                    src={
                                      "https://dev-portals-images.s3.amazonaws.com/NOL/products/toallas.svg"
                                    }
                                    alt=""
                                  />
                                )}
                              {items.category === "Protectores Diarios" &&
                                !items.gift && (
                                  <img
                                    className="f-mypoints-result-search-img"
                                    src={
                                      "https://dev-portals-images.s3.amazonaws.com/NOL/products/protectores.svg"
                                    }
                                    alt=""
                                  />
                                )}
                              {items.category === "Nosotras Lacti" &&
                                !items.gift && (
                                  <img
                                    className="f-mypoints-result-search-img"
                                    src={
                                      "https://dev-portals-images.s3.amazonaws.com/NOL/products/lacti.svg"
                                    }
                                    alt=""
                                  />
                                )}
                              {items.category === "Pañitos Húmedos Intimos" &&
                                !items.gift && (
                                  <img
                                    className="f-mypoints-result-search-img"
                                    src={
                                      "https://dev-portals-images.s3.amazonaws.com/NOL/products/pa%C3%B1itos.svg"
                                    }
                                    alt=""
                                  />
                                )}
                              {items.category === "Tampones" && !items.gift && (
                                <img
                                  className="f-mypoints-result-search-img"
                                  src={
                                    "https://dev-portals-images.s3.amazonaws.com/NOL/products/tampones.svg"
                                  }
                                  alt=""
                                />
                              )}
                              {items.category === "Jabón Íntimo" &&
                                !items.gift && (
                                  <img
                                    className="f-mypoints-result-search-img"
                                    src={
                                      "https://dev-portals-images.s3.amazonaws.com/NOL/products/jabon.svg"
                                    }
                                    alt=""
                                  />
                                )}
                              {btnActive === "Concursos" && (
                                <img
                                  className="f-mypoints-result-search-img"
                                  src={
                                    "https://dev-portals-images.s3.amazonaws.com/NOL/products/concursos.svg"
                                  }
                                  alt=""
                                />
                              )}
                              {((btnActive === "Acumulados" && items.gift) ||
                                items.category === "Regalo") && (
                                <img
                                  className="f-mypoints-result-search-img"
                                  src={
                                    "https://dev-portals-images.s3.amazonaws.com/NOL/products/regalo.svg"
                                  }
                                  alt=""
                                />
                              )}
                              {items.category === "Nosotras Maternidad" &&
                                !items.gift && (
                                  <img
                                    className="f-mypoints-result-search-img"
                                    src={
                                      "https://dev-portals-images.s3.amazonaws.com/NOL/products/toallas.svg"
                                    }
                                    alt=""
                                  />
                                )}
                              {items.category === "Cuidado V" &&
                                !items.gift && (
                                  <img
                                    className="f-mypoints-result-search-img"
                                    src={
                                      "https://dev-portals-images.s3.amazonaws.com/NOL/products/Sensitiv.svg"
                                    }
                                    alt=""
                                  />
                                )}
                            </div>
                            <div className="f-mypoints-result-search-container-info">
                              <div className="f-info-name">
                                <h6 className="f-info-name-title">
                                  {items.gift ? "Regalo Nosotras" : items.title}
                                </h6>
                                {btnActive === "Acumulados" && (
                                  <p>
                                    {!items.gift
                                      ? items.key &&
                                        `Clave: ${items.key.toUpperCase()}`
                                      : items.detail}
                                  </p>
                                )}
                                <p>{FormatDate(items.creationDate)}</p>
                              </div>
                              <div className="f-info-point">
                                <h6
                                  className={
                                    "f-info-name-title " +
                                    (items.points < 0 ? "f-points-color" : "")
                                  }
                                >
                                  {items.points} puntos
                                </h6>
                                {btnActive === "Acumulados" && (
                                  <p>Vencimiento:</p>
                                )}
                                {btnActive === "Acumulados" && (
                                  <p>{FormatDate(items.expirationDate)}</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </>
                ) : (
                  <>
                    {data &&
                      data.map((items, index) => (
                        <CardMyPoints
                          key={index}
                          items={items}
                          btnActive={btnActive}
                        />
                      ))}
                  </>
                )}
              </div>
            </>
          ) : (
            <div>
              {(btnActive === "Acumulados" || btnActive === "Concursos") &&
              requestMade ? (
                <EmptyHistory
                  message={
                    btnActive === "Concursos"
                      ? "Aún no has redimido nada, te invitamos a participar en nuestras actividades."
                      : btnActive === "Acumulados"
                      ? "Aún no has acumulado puntos. Ingresa claves para comenzar acumular."
                      : ""
                  }
                  titlebtn={
                    btnActive === "Concursos"
                      ? "Ir a concursos"
                      : btnActive === "Acumulados"
                      ? "Ingresar claves"
                      : ""
                  }
                  action={
                    btnActive === "Concursos"
                      ? competitionRedirect
                      : btnActive === "Acumulados"
                      ? keyScroll
                      : ""
                  }
                />
              ) : (
                <div className="f-loading-my-points">
                  <Loader
                    type="TailSpin"
                    color="#FF409B"
                    height={50}
                    width={50}
                  />
                </div>
              )}
            </div>
          )}
        </>
      )}

      {btnActive === "Pedidos" && (
        <>
          {listRedem.length > 0 ? (
            <div className="f-mypoints-seccion-result">
              {listRedem.map((items, index) => {
                return <CardOrders key={index} mobile={mobile} items={items} />
              })}
            </div>
          ) : (
            <>
              {!requestMade ? (
                <div className="f-loading-my-points">
                  <Loader
                    type="TailSpin"
                    color="#FF409B"
                    height={50}
                    width={50}
                  />
                </div>
              ) : (
                <>
                  {btnActive === "Pedidos" && requestMade && (
                    <EmptyHistory
                      message={
                        "Aún no has hecho ningún pedido. Comienza a redimir."
                      }
                      titlebtn={"Ir a tienda"}
                      action={storeRedirect}
                    />
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

      {btnActive === "Muestras" && (
        <>
          {listSamples.length > 0 ? (
            <div className="f-mypoints-seccion-result">
              {listSamples.map((items, index) => {
                return <CardSamples key={`sample-${index}`} info={items} />
              })}
            </div>
          ) : (
            <>
              {!requestMade ? (
                <div className="f-loading-my-points">
                  <Loader
                    type="TailSpin"
                    color="#FF409B"
                    height={50}
                    width={50}
                  />
                </div>
              ) : (
                <>
                  {btnActive === "Muestras" && requestMade && (
                    <EmptyHistory
                      message={
                        "Aún no has hecho ningún pedido. Comienza a redimir."
                      }
                      titlebtn={"Ir a tienda"}
                      action={storeRedirect}
                    />
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

      <div className="f-pagination">
        {totalPagesAccummulated > 1 &&
          (data.length > 0 || listRedem > 0 || listSamples.length > 0) && (
            <div className="f-pagination-container">
              <Paginator
                totalPageButtons={5}
                totalPages={totalPagesAccummulated}
                fetchPage={fetchPage}
              />
            </div>
          )}
      </div>
    </div>
  )
}

export default MyPoints
